import '../types/index.js';
import '../checkout-Ee1eEXQH.js';
import { U as UrlType } from '../menu-0TyOg98i.js';
import '../product-_pRduMz7.js';
import '../modal-6vnX5SO3.js';
import { getCategoryLink } from './category.js';
import { getProductLink } from './product.js';
import 'lodash/get';
import '../cookies-VX_DpI1q.js';
import '../paths-ZKN3m62_.js';
import '../GetCategoryBanner-6p0nM8yz.js';
import '../GetCategoryYmals-ZnB1VGnf.js';
import '../UrlResolver-yh_X8hA9.js';
import '../requestsCollection-A0HzS4ai.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../services/auth/index.js';
import './logToSlack.js';
import './cookies.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import './isBot.js';
import './currency.js';
import '../context/index.js';
import 'next/router';
import '../helpers-WYINLSKJ.js';
import 'lodash';
import './fetchPolicyLookup.js';
import './error.js';
import '../serverErrors-O6unZmFR.js';
import './logger.js';
import './logToRelic.js';

const formatUrl = (url, urlType) => {
    switch (urlType) {
        case UrlType.Category: {
            return getCategoryLink(url);
        }
        case UrlType.Product: {
            return getProductLink(url);
        }
        default: {
            return url;
        }
    }
};
const proceedItems = (items) => {
    if (!items)
        return [];
    return items.map(item => ({
        ...item,
        url: formatUrl(item.url, item.url_type),
        children: proceedItems(item === null || item === void 0 ? void 0 : item.children),
    }));
};
const formatMenuUrls = (menu) => {
    if (!menu)
        return menu;
    return { ...menu, items: proceedItems(menu.items) };
};
var menu = {};

export { menu as default, formatMenuUrls };
//# sourceMappingURL=menu.js.map
